import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'm-chart-scatter-icon',
  templateUrl: 'chart-scatter-icon.component.html'
})
export class ChartScatterIconComponent {
  constructor() {}
}
